import { Injector, Pipe, PipeTransform } from '@angular/core';
import { intersect } from '../../../../../submodules/common/util';
import { SecurityDataService } from '../../angular-common/security-data.service';

// Esempio di come chiamare una pipe con più parametri (dove arg1 è quello su cui viene applicata la pipe):
// {{ arg1 | myPipe:arg2 }}
// {{ arg1 | myPipe:arg2:arg3 }}
@Pipe({
  name: 'ownedByPrincipal'
})
export class OwnedByPrincipalPipe implements PipeTransform {

  constructor(protected _injector: Injector){}

  transform(requiredAuthorities: string[]): boolean {
    return intersect(this._injector.get(SecurityDataService).userProfile.authorities, requiredAuthorities).length==requiredAuthorities.length
  }
}
